function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

////////// Attributes //////////
/// Gets an attribute and converts it to boolean
///
/// @param key    The attribute name
HTMLElement.prototype.getBooleanAttribute = function (key) {
  return this.hasAttribute(key) && this.getAttribute(key) !== 'false';
}; /// Gets an attribute and converts it to a date
///
/// @param key    The attribute name


HTMLElement.prototype.getDateAttribute = function (key) {
  return new Date(this.getAttribute(key)) || null;
}; /// Gets an attribute and converts it to a Json object
///
/// @param key    The attribute name


HTMLElement.prototype.getJsonAttribute = function (key) {
  return JSON.parse(this.getAttribute(key)) || null;
}; /// Gets an attribute and converts it to an integer
///
/// @param key    The attribute name


HTMLElement.prototype.getIntegerAttribute = function (key) {
  var val = parseInt(this.getAttribute(key), 10);

  if (typeof val === 'number') {
    return val;
  } else {
    return null;
  }
}; /// Gets an attribute and converts it to a float
///
/// @param key    The attribute name


HTMLElement.prototype.getFloatAttribute = function (key) {
  var val = parseFloat(this.getAttribute(key), 10);

  if (typeof val === 'number') {
    return val;
  } else {
    return null;
  }
}; ////////// Styles //////////
/// Gets the computed style for an element


HTMLElement.prototype.getComputedStyle = function () {
  return window.getComputedStyle(this);
}; ////////// Scrolling //////////
// Element/Parent Scrolling
/// Check if an element is scrollable


Object.defineProperty(HTMLElement.prototype, 'scrollable', {
  get: function scrollable() {
    return this.scrollableX || this.scrollableY;
  }
}); /// Check if an element is horizontally scrollable

Object.defineProperty(HTMLElement.prototype, 'scrollableX', {
  get: function scrollable() {
    if (this !== document.documentElement) {
      var overflowX = this.getComputedStyle().overflowX;

      if (overflowX !== 'auto' && overflowX !== 'scroll') {
        return false;
      }
    }

    return this.scrollWidth > this.clientWidth;
  }
}); /// Check if an element is vertically scrollable

Object.defineProperty(HTMLElement.prototype, 'scrollableY', {
  get: function scrollable() {
    if (this !== document.documentElement) {
      var overflowY = this.getComputedStyle().overflowY;

      if (overflowY !== 'auto' && overflowY !== 'scroll') {
        return false;
      }
    }

    return this.scrollHeight > this.clientHeight;
  }
}); /// Check if an element's parent is scrollable

Object.defineProperty(HTMLElement.prototype, 'scrollableParent', {
  get: function scrollableParent() {
    var node = this.parentNode;

    while (node && !node.scrollable) {
      node = node.parentNode;
    }

    return node;
  }
});

var easeOut = function easeOut(t) {
  return 1 - --t * t * t * t;
};

var ELEMENT_SCROLL_PADDING_REM = 5; /// Scroll an element to a particular position.
/// Animations use an ease-out timing function
///
/// @param endOffsetX         The X position to scroll to
/// @param endOffsetY         The Y position to scroll to
/// @param options.animated   Whether or not to animate the scrolling
/// @param options.duration   The length of the animation

HTMLElement.prototype.scroll = function (endOffsetX, endOffsetY) {
  var _this = this;

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var startOffsetX = this.scrollLeft;
  var deltaX;

  if (endOffsetX) {
    deltaX = endOffsetX - startOffsetX;
  } else {
    deltaX = startOffsetX;
  }

  var startOffsetY = this.scrollTop;
  var deltaY;

  if (endOffsetY) {
    deltaY = endOffsetY - startOffsetY;
  } else {
    deltaY = startOffsetY;
  }

  if (options.animated) {
    var duration = options.duration || 300;
    var startTime = null;

    var step = function step(timestamp) {
      startTime = startTime || timestamp;
      var currentTime = timestamp - startTime;
      var progress = Math.min(1, Math.max(0, currentTime / duration));
      progress = easeOut(progress);
      _this.scrollLeft = startOffsetX + progress * deltaX;
      _this.scrollTop = startOffsetY + progress * deltaY;

      if (currentTime < duration) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  } else {
    this.scrollLeft = endOffsetX;
    this.scrollTop = endOffsetY;
  }
}; /// Scroll an element into view.
/// Only scrolls the minimum amount required to make the element visible, plus some padding.
///
/// @param options    See HTMLElement.prototype.scroll


HTMLElement.prototype.scrollIn = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parent = this.scrollableParent;

  if (!parent) {
    return;
  }

  var offsetX = null;
  var offsetY = null;
  var padding = ELEMENT_SCROLL_PADDING_REM * parseFloat(getComputedStyle(document.documentElement).fontSize);

  if (parent.scrollableX) {
    var parentWidth = parent.offsetWidth;
    var parentBoundLeft = parent.scrollLeft;
    var parentBoundRight = parentBoundLeft + parentWidth;
    var left = this.offsetLeft;
    var right = left + this.offsetWidth;

    if (right > parentBoundRight - padding) {
      offsetX = right + padding - parentWidth;
    } else if (left < parentBoundLeft + padding) {
      offsetX = left - padding;
    }
  }

  if (parent.scrollableY) {
    var parentHeight = parent.offsetHeight;
    var parentBoundTop = parent.scrollTop;
    var parentBoundBottom = parentBoundTop + parentHeight;
    var top = this.offsetTop;
    var bottom = top + this.offsetHeight;

    if (bottom > parentBoundBottom - padding) {
      offsetY = bottom + padding - parentHeight;
    } else if (top < parentBoundTop + padding) {
      offsetY = top - padding;
    }
  }

  if (offsetX || offsetY) {
    parent.scroll(offsetX, offsetY, options);
  }
}; /// Scroll an element to the center of view.
///
/// @param options    See HTMLElement.prototype.scroll


HTMLElement.prototype.scrollInCenter = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parent = this.scrollableParent;

  if (!parent) {
    return;
  }

  var offsetX = null;
  var offsetY = null;

  if (parent.scrollableX) {
    var parentCenter = parent.offsetWidth / 2;
    var elementCenter = this.offsetLeft + this.offsetWidth / 2;
    offsetX = elementCenter - parentCenter;
  }

  if (parent.scrollableY) {
    var _parentCenter = parent.offsetHeight / 2;

    var _elementCenter = this.offsetTop + this.offsetHeight / 2;

    offsetY = _elementCenter - _parentCenter;
  }

  if (offsetX || offsetY) {
    parent.scroll(offsetX, offsetY, options);
  }
}; /// Workaround for a Chrome issue.
///
/// When an element is constructed, the inner contents are not always available. Waits for innerHTML to be available
/// before running setup.


var CustomHTMLElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomHTMLElement, _HTMLElement);

  var _super = _createSuper(CustomHTMLElement);

  function CustomHTMLElement() {
    var _this2;

    _classCallCheck(this, CustomHTMLElement);

    _this2 = _super.call(this);
    var elementType = window.customElements.get(_this2.tagName.toLowerCase()).name;
    var trace = new Error().stack.split('\n');
    var traceIndex = trace.length;

    while (trace[traceIndex - 1] === '' && traceIndex > 0) {
      traceIndex--;
    }

    if (trace[traceIndex - 1].includes(elementType)) {// created from the dom
    } else if (_this2._checkBody()) {
      // created by js, we can safely run the setup code
      _this2._setup = true;

      _this2._runSetup.apply(_assertThisInitialized(_this2), arguments); // forward constructor arguments to setup function

    }

    return _this2;
  }

  _createClass(CustomHTMLElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;

      if (!this._setup) {
        if (!this._checkBody()) {
          return;
        }

        this._setup = true;

        if (this.innerHTML && this.innerHTML.length && this._runSetup) {
          this._runSetup();

          this._runConnected();
        } else {
          var onwait = function onwait() {
            if (_this3._runSetup) {
              _this3._runSetup();

              _this3._runConnected();
            } else {
              setTimeout(onwait, 100);
            }
          };

          setTimeout(onwait);
        }
      } else if (this._runConnected) {
        this._runConnected();
      }
    }
  }, {
    key: "_checkBody",
    value: function _checkBody() {
      var parentNode = this.parentNode;

      while (parentNode !== null) {
        if (parentNode.tagName === 'BODY') {
          if (parentNode === document.body) {
            return true;
          } else {
            return false;
          }
        }

        parentNode = parentNode.parentNode;
      }

      return true;
    }
  }, {
    key: "_runSetup",
    value: function _runSetup() {}
  }, {
    key: "_runConnected",
    value: function _runConnected() {}
  }]);

  return CustomHTMLElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

export { CustomHTMLElement as default };